module.exports = __webpack_public_path__ + "static/media/GameBoardImage.a36b7e86.jpg";